import React from "react";

export default function SureheldLogo({ className = "h-10", testId = "sureheld-logo" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid={testId}>
      <img
        src="/sureheld-icon.png"
        alt=""
        className="h-10 w-10 rounded-full bg-white object-contain shrink-0"
      />
      <span className="inline-flex items-baseline gap-0.5 font-semibold tracking-tight text-white text-xl leading-none">
        <span aria-hidden="true">$</span>
        <span>Sureheld</span>
      </span>
    </span>
  );
}
